import React from 'react';
import { ToastMessage } from './ToastMessage';

interface ToastTypeProps {
  title: string;
  subtitle: string;
  customStyleToast?: any;
  customStyleTitle?: any;
  customStyleSubtitle?: any;
  status?: string;
}

export const Toast = ({
  title,
  subtitle,
  customStyleToast,
  customStyleTitle,
  customStyleSubtitle,
  status,
}: ToastTypeProps) => (
  <ToastMessage
    title={title}
    subtitle={subtitle}
    customStyleToast={customStyleToast}
    customStyleTitle={customStyleTitle}
    customStyleSubtitle={customStyleSubtitle}
    status={status}
  />
);
